<script setup>
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  stopwatch: Object,
  small: Boolean,
  showDays: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['timeline'])

const stopwatch = computed(() => {
  return [
    ...(props.showDays ? [{ value: props.stopwatch.days, label: props.stopwatch.days === 1 ? 'Dag' : 'Dagen' }] : []),
    { value: props.stopwatch.hours.toString().padStart(2, '0'), label: 'Uur' },
    { value: props.stopwatch.minutes.toString().padStart(2, '0'), label: 'Minuten' },
    { value: props.stopwatch.seconds.toString().padStart(2, '0'), label: 'Seconden' },
  ]
})

const stopwatchElement = ref(null)

onMounted(() => {
  const timeline = gsapTimeline({ name: 'StopwatchBlocks' }).from(stopwatchElement.value.children, { scale: 0, opacity: 0, stagger: 0.1, duration: frames(15), ease: 'back.out(2)' })

  emit('timeline', timeline)
})
</script>

<template>
  <div ref="stopwatchElement" class="leading-none grid gap-12" :class="{ 'gap-6': small, 'grid-cols-4': stopwatch.length === 4, 'grid-cols-3': stopwatch.length === 3 }">
    <div v-for="{ value, label } in stopwatch" :key="label" class="bg-white flex flex-col justify-center items-center" :class="small ? 'size-48 rounded-[4rem]' : 'rounded-[6rem] size-72'">
      <div class="text-q-cr-red-primary font-cervo-mono tracking-[-3px] tabular-nums" :class="small ? 'text-[8rem] -mb-7' : 'text-[12rem] -mb-10'">{{ value }}</div>
      <div class="font-blackbones text-q-cr-gray-primary lowercase" :class="small ? 'text-[2.5rem]' : 'text-[3rem]'">{{ label }}</div>
    </div>
  </div>
</template>
